import React, { useEffect, useState, JSX } from 'react';

import { ApiFilterOption } from '@ibe/api';
import { sanitize } from '@ibe/services';
import useTranslation from '../../../Hooks/useTranslation';
import fallback from '../../../../_Translations/generated/filter-dropdown.en.t.json';
import Keys from '../../../../_Translations/generated/filter-dropdown.en.t.json.keys';
import { Select } from '../../Form/Select/Select';

export interface Props {
  placeHolder?: string;
  options: ApiFilterOption[];
  selected?: ApiFilterOption | undefined;
  onChange?: (selected: ApiFilterOption) => void;
}

const FilterDropDown = (props: Props): JSX.Element => {
  const { onChange, options, selected, placeHolder } = props;

  const { t } = useTranslation('filter-dropdown', fallback, Keys);

  const [select, setSelected] = useState<ApiFilterOption | undefined>(selected);
  useEffect((): void => setSelected(selected), [selected]);

  const doOnChange = (option: ApiFilterOption): void => {
    if (onChange) {
      onChange(option);
    }
  };

  const getValue = (v: ApiFilterOption): string => {
    return v.value;
  };

  const getLabel = (v: ApiFilterOption): string => {
    return t(v.label);
  };

  const getOptions = (): ApiFilterOption[] => {
    return options.filter(o => o.results !== 0);
  };

  return (
    <>
      <Select
        isClearable
        options={getOptions()}
        selectedOption={select}
        placeholder={placeHolder}
        onChange={doOnChange}
        getLabel={getLabel}
        formatOptionLabel={(v: ApiFilterOption): string | JSX.Element => {
          return (!select || v.id !== select.id) && Number.isInteger(v.results) ? (
            <>
              <section>
                <span dangerouslySetInnerHTML={{ __html: sanitize(getLabel(v)) }} />
                {Number.isInteger(v.results) && (
                  <span
                    className="iso__baseLayoutFilter__filterCount"
                    dangerouslySetInnerHTML={{ __html: sanitize(v.results?.toString() || '') }}
                  />
                )}
              </section>
            </>
          ) : (
            <span> {getLabel(v)} </span>
          );
        }}
        getValue={getValue}
      />
    </>
  );
};

export default FilterDropDown;
